import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import Specializations from 'profile/components/specializations';

export default connect(mapProfileToProps)(Specializations);



// WEBPACK FOOTER //
// ./profile/containers/specializations.js